import { render, staticRenderFns } from "./TimeSpentTaskList.vue?vue&type=template&id=784edeaa&scoped=true&"
import script from "./TimeSpentTaskList.vue?vue&type=script&lang=js&"
export * from "./TimeSpentTaskList.vue?vue&type=script&lang=js&"
import style0 from "./TimeSpentTaskList.vue?vue&type=style&index=0&id=784edeaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784edeaa",
  null
  
)

export default component.exports